import React, { useRef, useState, useCallback } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Spinner } from 'reactstrap';
import './style.scss';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

// Configure PDF.js worker - Using CDN for better production compatibility
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

var angle = 0;

const PdfViewer = (props) => {
  const pdf = useRef(null);
  const [scale, setScale] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  let tapCount = 0;
  const { source, iden } = props;

  // Convert source to react-pdf compatible format
  const getPdfSource = useCallback(() => {
    if (!!source?.base64) {
      return `data:application/pdf;base64,${source.base64}`;
    }
    return source;
  }, [source]);

  const onDocumentLoadSuccess = (pdfDocument) => {
    setNumPages(pdfDocument.numPages);
    setLoading(false);
    setError(null);
  };

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF:', error);
    setError('Failed to load PDF document');
    setLoading(false);
  };

  const handleDocumentClick = (e) => {
    if (tapCount == 1) {
      tapCount = 0;
      if (scale == 1.2) {
        setScale(1);
      } else {
        setScale(1.2);
      }

      if (scale != 1.2) {
        document.getElementById(iden).classList.add('zoomin');
      } else {
        document.getElementById(iden).classList.remove('zoomin');
      }
    } else {
      tapCount++;
    }
  };

  const handlePrevClick = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const handleNextClick = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const handleRotateLeft = () => {
    document.getElementById(iden).classList.remove(`pdf-doc-view-${angle}`);
    if (angle === 0) {
      angle = 270;
    } else {
      angle = angle - 90;
    }
    document.getElementById(iden).classList.add(`pdf-doc-view-${angle}`);
  };

  const handleRotateRight = () => {
    document.getElementById(iden).classList.remove(`pdf-doc-view-${angle}`);
    if (angle === 270) {
      angle = 0;
    } else {
      angle = angle + 90;
    }
    document.getElementById(iden).classList.add(`pdf-doc-view-${angle}`);
  };

  const renderLoader = () => (
    <div className="bottom-infinite-loader">
      <Spinner color={'red'} />
    </div>
  );

  const renderError = () => (
    <div className="pdf-error">
      <p>{error}</p>
    </div>
  );

  const renderNavigation = () => (
    <nav className="pdf-pagination-box">
      <button
        className="head-icon"
        onClick={handleRotateLeft}
      >
        <i className="fas fa-undo"></i>
      </button>
      {pageNumber != 1 && (
        <button onClick={handlePrevClick}>
          Prev
        </button>
      )}
      <span>
        Page {pageNumber} of {numPages}
      </span>
      {pageNumber != numPages && (
        <button onClick={handleNextClick}>
          Next
        </button>
      )}
      <button
        className="head-icon"
        onClick={handleRotateRight}
      >
        <i className="fas fa-redo"></i>
      </button>
    </nav>
  );

  if (error) {
    return renderError();
  }

  const pdfSource = getPdfSource();
  
  if (!pdfSource) {
    return (
      <div className="pdf-error">
        <p>Invalid PDF source provided</p>
      </div>
    );
  }

  return (
    <div>
      <div id={iden} className="pdf-doc-view-parent">
        <div className="pdf-doc-box" onClick={handleDocumentClick} ref={pdf}>
          <Document
            file={pdfSource}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={onDocumentLoadError}
            loading={renderLoader()}
            error={renderError()}
            className="pdf-main-box"
          >
            {numPages && (
              <Page
                pageNumber={pageNumber}
                scale={scale}
                loading={renderLoader()}
                className="pdf-page"
              />
            )}
          </Document>
        </div>
        {numPages && renderNavigation()}
      </div>
    </div>
  );
};

export default PdfViewer;